export type WorkoutStyle = {
  emoji: string;
  label: string;
  backgroundColor: string;
  color: string;
};

const WORKOUT_STYLE_CONFIG: Record<string, WorkoutStyle> = {
  running: { emoji: '🏃', label: 'Running', backgroundColor: 'rgba(99, 102, 241, 0.12)', color: '#4f46e5' },
  run: { emoji: '🏃', label: 'Running', backgroundColor: 'rgba(99, 102, 241, 0.12)', color: '#4f46e5' },
  walking: { emoji: '🚶', label: 'Walking', backgroundColor: 'rgba(34, 197, 94, 0.12)', color: '#16a34a' },
  walk: { emoji: '🚶', label: 'Walking', backgroundColor: 'rgba(34, 197, 94, 0.12)', color: '#16a34a' },
  hiking: { emoji: '🥾', label: 'Hiking', backgroundColor: 'rgba(245, 158, 11, 0.12)', color: '#d97706' },
  cycling: { emoji: '🚴', label: 'Cycling', backgroundColor: 'rgba(249, 115, 22, 0.12)', color: '#ea580c' },
  cycle: { emoji: '🚴', label: 'Cycling', backgroundColor: 'rgba(249, 115, 22, 0.12)', color: '#ea580c' },
  biking: { emoji: '🚴', label: 'Cycling', backgroundColor: 'rgba(249, 115, 22, 0.12)', color: '#ea580c' },
  swimming: { emoji: '🏊', label: 'Swimming', backgroundColor: 'rgba(59, 130, 246, 0.12)', color: '#2563eb' },
  swim: { emoji: '🏊', label: 'Swimming', backgroundColor: 'rgba(59, 130, 246, 0.12)', color: '#2563eb' },
  strength: { emoji: '🏋️', label: 'Strength', backgroundColor: 'rgba(245, 158, 11, 0.12)', color: '#d97706' },
  strength_training: { emoji: '🏋️', label: 'Strength', backgroundColor: 'rgba(245, 158, 11, 0.12)', color: '#d97706' },
  gym: { emoji: '💪', label: 'Gym', backgroundColor: 'rgba(245, 158, 11, 0.12)', color: '#d97706' },
  cardio: { emoji: '❤️', label: 'Cardio', backgroundColor: 'rgba(244, 63, 94, 0.12)', color: '#e11d48' },
  hiit: { emoji: '🔥', label: 'HIIT', backgroundColor: 'rgba(239, 68, 68, 0.12)', color: '#dc2626' },
  yoga: { emoji: '🧘', label: 'Yoga', backgroundColor: 'rgba(236, 72, 153, 0.12)', color: '#db2777' },
  pilates: { emoji: '🧘‍♀️', label: 'Pilates', backgroundColor: 'rgba(217, 70, 239, 0.12)', color: '#c026d3' },
  rowing: { emoji: '🚣', label: 'Rowing', backgroundColor: 'rgba(45, 212, 191, 0.12)', color: '#0f766e' },
  tennis: { emoji: '🎾', label: 'Tennis', backgroundColor: 'rgba(132, 204, 22, 0.12)', color: '#65a30d' },
  basketball: { emoji: '🏀', label: 'Basketball', backgroundColor: 'rgba(249, 115, 22, 0.12)', color: '#ea580c' },
  soccer: { emoji: '⚽', label: 'Soccer', backgroundColor: 'rgba(34, 197, 94, 0.12)', color: '#16a34a' },
  football: { emoji: '🏈', label: 'Football', backgroundColor: 'rgba(245, 158, 11, 0.12)', color: '#d97706' },
  boxing: { emoji: '🥊', label: 'Boxing', backgroundColor: 'rgba(239, 68, 68, 0.12)', color: '#dc2626' },
  surfing: { emoji: '🏄', label: 'Surfing', backgroundColor: 'rgba(6, 182, 212, 0.12)', color: '#0891b2' },
  dancing: { emoji: '💃', label: 'Dancing', backgroundColor: 'rgba(236, 72, 153, 0.12)', color: '#db2777' },
  workout: { emoji: '⚡', label: 'Workout', backgroundColor: 'rgba(250, 204, 21, 0.12)', color: '#ca8a04' },
  other: { emoji: '🏅', label: 'Activity', backgroundColor: 'rgba(148, 163, 184, 0.12)', color: '#64748b' }
};

export function getWorkoutStyle(type: string | null | undefined): WorkoutStyle {
  if (!type) return WORKOUT_STYLE_CONFIG.other;

  const normalizedType = type.toLowerCase().trim();

  if (WORKOUT_STYLE_CONFIG[normalizedType]) {
    return WORKOUT_STYLE_CONFIG[normalizedType];
  }

  for (const [key, config] of Object.entries(WORKOUT_STYLE_CONFIG)) {
    if (normalizedType.includes(key) || key.includes(normalizedType)) {
      return config;
    }
  }

  const formattedLabel = type
    .split(/[_\s]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

  return {
    ...WORKOUT_STYLE_CONFIG.other,
    label: formattedLabel
  };
}
